<template>
    <veui-dialog
        ui="auto"
        title="我的回答"
        :open="show"
        overlay-class="detail-modal"
        @cancel="close"
    >
        <div class="content">
            <div class="question">
                {{ quesInfo.qTitle || quesInfo.question }}
            </div>
            <div class="date">
                {{ quesInfo.dispatch_time | dateFilter }}
            </div>
            <div class="reply ql-container ql-snow">
                <!--bca-disable-next-line-->
                <div class="ql-editor" v-html="quesInfo.reply_content"></div>
            </div>
        </div>
        <div slot="foot" class="footer">
            <veui-button ui="l primary" class="btn" @click="close">
                确定
            </veui-button>
        </div>
    </veui-dialog>
</template>

<script>
/**
 * @file search-form.vue
 * @desc 筛选表单
 * @author xingminghua@baidu.com
 */
import { Dialog, Button } from 'veui';
import { pastTimeBlur } from '@/utils/util';

export default {
    name: 'detail-modal',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    filters: {
        dateFilter(value) {
            if (!value) {
                return '-';
            }
            return pastTimeBlur(value);
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        quesInfo: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="less" scoped>
.detail-modal {
    /deep/ .veui-dialog-content {
        width: 840px;
        height: 570px;
        padding: 0;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        .veui-dialog-content-head {
            background-color: transparent;
            position: relative;
            padding: 23px 24px 28px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            font-weight: 500;
            .veui-dialog-content-head-close {
                position: absolute;
                top: 24px;
                right: 24px;
            }
        }
        .veui-dialog-content-body {
            padding: 2px 0;
        }
        .veui-dialog-content-foot {
            padding: 0;
        }
    }
    .content {
        width: 100%;
        height: 399px;
        display: flex;
        flex-direction: column;
        padding: 24px 24px 0;
        .question {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #333333;
            font-weight: 700;
            padding: 0 24px;
        }
        .date {
            margin: 12px 24px 0;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            line-height: 1;
            color: #999999;
            padding-bottom: 6px;
            border-bottom: 1px solid rgba(244, 244, 244, 1);
        }
        .reply {
            margin-top: 17px;
            width: 100%;
            overflow: auto;
            border: none;
            .ql-editor {
                padding: 0 24px;
            }
        }
    }
    .footer {
        position: absolute;
        height: 104px;
        padding-top: 36px;
        width: 100%;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        .btn {
            width: 98px;
            height: 40px;
            border-radius: 5px;
            background: #3855d5;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            font-weight: 500;
        }
    }
}
</style>